"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawAction = void 0;
class RawAction {
    constructor() {
        this.account = ''; // 'testeostoken',
        this.name = ''; // 'transfer',
        this.authorization = new Array();
    }
}
exports.RawAction = RawAction;
